import React, {Component} from 'react';
import {Modal, ModalHeader, ModalBody, ModalFooter} from 'reactstrap';
import {APIClient} from '../../utils/APIClient';
import {API_URL} from '../../settings/local_settings';
import {Spinner} from '../Spinner';
import {ConfigureEventsModal} from '../data_explorer/ConfigureEventsModal';
import {BUSINESS_TYPE_OPTIONS} from '../client/ClientProfileForm';
import {withTranslation} from 'react-i18next';
import './ReportPreGenerationWizard.scss';


class ReportPreGenerationWizardClass extends Component {
    constructor(props) {
        super(props);
        this.state = {
            step: 'checking',
            profileData: null,
            businessType: '',
            unconfiguredAccounts: [],
            needsEvents: false,
            saving: false,
            error: null,
        };
        this.handleProfileContinue = this.handleProfileContinue.bind(this);
        this.handleEventsComplete = this.handleEventsComplete.bind(this);
    }

    componentDidMount() {
        this.runChecks();
    }

    runChecks() {
        const {clientId, scope} = this.props;

        let eventsUrl = `${API_URL}client/${clientId}/ad-accounts/events-check`;
        if (scope?.business_unit_id) {
            eventsUrl += `?business_unit_ids=${scope.business_unit_id}`;
        }

        const profilePromise = new APIClient(`${API_URL}client/${clientId}/profile`).call('GET');
        const eventsPromise = new APIClient(eventsUrl).call('GET');

        Promise.all([profilePromise, eventsPromise]).then(([profileRes, eventsRes]) => {
            const profileData = profileRes?.status === 'OK' ? profileRes.data : null;
            const eventsData = eventsRes?.status === 'OK' ? eventsRes.data : null;
            const needsProfile = !profileData?.business_type;
            const unconfiguredAccounts = eventsData?.unconfigured_accounts || [];
            const needsEvents = unconfiguredAccounts.length > 0;

            if (!needsProfile && !needsEvents) {
                this.props.onValidationComplete();
                return;
            }

            this.setState({
                profileData,
                unconfiguredAccounts,
                needsEvents,
                step: needsProfile ? 'profile' : 'events',
            });
        }).catch(() => {
            this.props.onValidationComplete();
        });
    }

    handleProfileContinue() {
        const {clientId} = this.props;
        const {businessType, profileData, needsEvents} = this.state;

        this.setState({saving: true, error: null});

        new APIClient(`${API_URL}client/${clientId}/profile`).call('PUT', {
            business_type: businessType || null,
            industry: profileData?.industry || null,
            primary_kpi: profileData?.primary_kpi || null,
            notes: profileData?.notes || null,
        }).then((data) => {
            this.setState({saving: false});
            if (data?.status === 'OK') {
                if (needsEvents) {
                    this.setState({step: 'events'});
                } else {
                    this.props.onValidationComplete();
                }
            } else {
                this.setState({error: data?.error_message || 'Error'});
            }
        }).catch(() => {
            this.setState({saving: false, error: 'Error'});
        });
    }

    handleEventsComplete() {
        this.props.onValidationComplete();
    }

    renderProfileStep() {
        const {t, onCancel} = this.props;
        const {businessType, saving, error} = this.state;

        return (
            <Modal isOpen={true} toggle={onCancel} className="report-wizard-modal">
                <ModalHeader toggle={onCancel}>
                    {t('report_wizard.profile_step_title')}
                </ModalHeader>
                <ModalBody>
                    <div className="report-wizard-profile">
                        <p className="report-wizard-description">
                            {t('report_wizard.profile_step_description')}
                        </p>
                        <div className="form-row">
                            <label>{t('client_profile.business_type')}:</label>
                            <select
                                value={businessType}
                                onChange={(e) => this.setState({businessType: e.target.value})}
                            >
                                <option value="">{t('client_profile.select_option')}</option>
                                {BUSINESS_TYPE_OPTIONS.map(opt => (
                                    <option key={opt.value} value={opt.value}>{t(opt.labelKey)}</option>
                                ))}
                            </select>
                        </div>
                        {error && <p className="text-danger" style={{marginTop: '0.5em'}}>{error}</p>}
                    </div>
                </ModalBody>
                <ModalFooter>
                    <button className="btn -negative" onClick={onCancel}>
                        {t('client_reports.cancel')}
                    </button>
                    <button
                        className="btn -alt"
                        onClick={this.handleProfileContinue}
                        disabled={!businessType || saving}
                    >
                        {saving ? <Spinner color="light" size="sm"/> : t('report_wizard.continue')}
                    </button>
                </ModalFooter>
            </Modal>
        );
    }

    renderEventsStep() {
        const {onCancel} = this.props;
        const {unconfiguredAccounts} = this.state;

        return (
            <ConfigureEventsModal
                isOpen={true}
                toggle={onCancel}
                unconfiguredAccounts={unconfiguredAccounts}
                onComplete={this.handleEventsComplete}
            />
        );
    }

    render() {
        const {step} = this.state;
        if (step === 'profile') return this.renderProfileStep();
        if (step === 'events') return this.renderEventsStep();
        return null;
    }
}

export const ReportPreGenerationWizard = withTranslation()(ReportPreGenerationWizardClass);
